<template lang="pug">
.match-bet-area-type
  .match-bet-area-type-title {{ betType == 'ou' ? $tc("m.BT_OUF", 2) : $tc("m.BT_OUH", 2) }}
  .match-odd-area
    .match-odd-area-oddtype
      p.mb-0 {{ $t("m.ODD_Over") }}
    template(v-if="Object.keys(details).length > 0 && details['tn'] > 0")
      template(v-for="(dn, i) in details['kns']")
        .match-odd-area-group
          template(v-if="details[betType] && details[betType][i] && details[betType][i][11] != 0 && details[betType][i][12] != 0 && details[betType][i][11] != '' && details[betType][i][12] != ''")
            oddsItemMMOX(:odds="details[betType][i]" idx=12 :typ="oddsType" dataType="1" :mode="betType" label="over" :count="i" :details="details" homeAway="1" pos=23)
          template(v-else)
            OddsDisabled
    template(v-else)
      .match-odd-area-group
        OddsDisabled
    .match-odd-area-oddtype
      p.mb-0 {{ $t("m.ODD_Under") }}
    template(v-if="Object.keys(details).length > 0 && details['tn'] > 0")
      template(v-for="(dn, i) in details['kns']")
        .match-odd-area-group
          template(v-if="details[betType] && details[betType][i] && details[betType][i][11] != 0 && details[betType][i][12] != 0 && details[betType][i][11] != '' && details[betType][i][12] != ''")
            oddsItemMMOX(:odds="details[betType][i]" idx=11 :typ="oddsType" dataType="1" :mode="betType" label="under" :count="i" :details="details" homeAway="2" pos=23)
          template(v-else)
            OddsDisabled
    template(v-else)
      .match-odd-area-group
        OddsDisabled
</template>

<script>
import oddsItemMMOX from "@/components/mobile/main/xitem/oddsItemMMOX";
import OddsDisabled from "@/components/mobile/main/xitem/oddsDisabled";

export default {
  components: {
    oddsItemMMOX,
    OddsDisabled
  },
  props: {
    details: {
      type: Object
    },
    oddsType: {
      type: String
    },
    i: {
      type: [String, Number]
    },
    betType: {
      type: String
    },
    homeAway: {
      type: String
    },
  }
};
</script>